import {
	actionCreator,
	asyncActionCreators,
} from "../../../lib/util/ReduxUtils";
import * as UserSelectors from "../../../store/User/User.selector";
import * as Api from "../../../Api";
import {
	InviteDriverInfo,
	InviteDriversState,
	InviteDriverValidation,
} from "./InviteDriversForm.reducer";
import { Falsy } from "../../../lib/types/UtilTypes";

export const updateStep = actionCreator("[INVITE DRIVERS] UPDATE_STEP");
export const updateType = actionCreator("[INVITE DRIVERS] UPDATE_TYPE");

export const sendInvites = asyncActionCreators<
	{
		invites: Array<{
			email: string;
			group: string | Falsy;
			reminder?: boolean;
		}>;
		sendAs: string | null;
		locale: string | undefined;
	},
	any
>("[INVITE DRIVERS] SEND_INVITES", async (action, dispatch, getState) => {
	const fleetId = UserSelectors.selectCurrentScopeFleetId(getState());
	const groupId = UserSelectors.selectCurrentScopeGroupId(getState());
	if (!fleetId) {
		throw new Error("Fleet ID missing");
	}
	const res = await Api.postInviteDrivers.submit({
		query: { group: groupId },
		params: { fleetId: fleetId },
		body: action.payload,
	});

	dispatch(updateStep("success"));
	return res.data;
});

export const resetForm = actionCreator<void>("[INVITE DRIVERS] RESET_FORM");

export const setDrivers = asyncActionCreators<
	{ isUsernameFlow: boolean; drivers: InviteDriverInfo[] },
	InviteDriversState
>("[INVITE DRIVERS] SET_DRIVERS", async (action, dispatch, getState) => {
	const { isUsernameFlow, drivers: allDrivers } = action.payload;
	const state = getState();
	const fleetId = UserSelectors.selectCurrentScopeFleetId(state);
	const group = UserSelectors.selectCurrentScopeGroupId(state);
	if (!fleetId) {
		throw new Error("Fleet ID missing");
	}

	const duplicates: string[] = [];
	const emailToInfo: Record<string, InviteDriverInfo> = {};
	const invites = allDrivers.filter((driver) => {
		const key = isUsernameFlow ? driver.username : driver.email;
		const unique = !emailToInfo[key!];

		if (unique) {
			emailToInfo[key!] = driver;
		}

		if (!unique && !duplicates.includes(key!)) {
			duplicates.push(key!);
		}

		return unique;
	});

	const res = await Api.postValidateInvites.submit({
		params: { fleetId: fleetId },
		query: { group },
		body: { invites: Object.keys(emailToInfo), usernames: isUsernameFlow },
	});

	const drivers: InviteDriverValidation[] = [];
	const managers: InviteDriverValidation[] = [];
	const invalid: InviteDriverValidation[] = [];

	for (const driver of res.data) {
		driver.providedGroup = driver.group;
		Object.assign(driver, emailToInfo[driver.email!]);

		if (driver.valid) {
			drivers.push(driver);
		} else {
			if (driver.managerOnly) {
				managers.push(driver);
			} else {
				if (!driver.exists) {
					driver.reminder = true;
				}
				invalid.push(driver);
			}
		}
	}

	const result: InviteDriversState = {
		duplicates,
		drivers,
		managers,
		invalid,
	};
	return result;
});

export const updateManualFormData = actionCreator(
	"[INVITE DRIVERS] UPDATE_MANUAL_FORM_DATA",
);
export const updateDrivers = actionCreator("[INVITE DRIVERS] UPDATE_DRIVERS");
export const confirmClose = actionCreator("[INVITE DRIVERS] CONFIRM_CLOSE");
export const errorsSeen = actionCreator("[INVITE DRIVERS] SEEN_ERRORS");
export const managersSeen = actionCreator("[INVITE DRIVERS] SEEN_MANAGERS");
